import BaseRepository from "../../../common/repository/base_repository";

export default class SignUpRepository extends BaseRepository {

    itemUrl = '/api/sign-up';

}